// Core UI strings for English (en) and Arabic (ar).
export const translations = {
  en: {
    // Brand / generic
    tagline: "Easy Tyres change anywhere",
    order_now: "Order Now",
    buy_now: "Buy Now",
    back: "Back",
    free_shipping: "Free Shipping",
    secure_payment: "Secure Payment",
    money_back: "30-Day Money Back",
    in_stock: "In Stock · Ready to Ship + Free Shipping",
    usd: "USD",
    total: "Total (incl. VAT)",
    quantity: "Quantity",
    special_offer: "Special Offer",
    save_shipping: "Save $200 + FREE Shipping",
    cod_payment: "COD Payment",

    // Nav
    nav_home: "Home",
    nav_product: "Product",
    nav_how_to_use: "How To Use",
    nav_about: "About",
    nav_blog: "Blog",
    nav_b2b: "B2B",
    nav_contact: "Contact",
    nav_track_order: "Track Order",

    // Track Order
    track_hero: "Track Your Order",
    track_sub: "Enter your Order ID to check the delivery status of your LCTX Tire Changer.",
    track_search_ph: "Enter your Order ID",
    track_btn: "Track Order",
    track_loading: "Looking up your order...",
    track_notfound: "We couldn't find an order with that ID. Please check and try again.",
    track_err: "Something went wrong. Please try again.",
    track_order_id_label: "Order ID",
    track_order_date: "Order Date",
    track_qty: "Quantity",
    track_total: "Total",
    track_dest: "Shipping To",
    track_payment: "Payment",
    track_placed: "Order Placed",
    track_placed_desc: "We received your order.",
    track_confirmed: "Confirmed",
    track_confirmed_desc: "Your order is confirmed and being prepared.",
    track_shipped: "Shipped",
    track_shipped_desc: "Your tire changer is on the way.",
    track_delivered: "Delivered",
    track_delivered_desc: "Your order has arrived. Enjoy your LCTX!",
    track_cancelled: "Order Cancelled",
    track_cancelled_desc: "This order was cancelled.",
    track_paid: "Paid",
    track_unpaid: "Awaiting Payment",

    // Footer
    footer_company: "LCTX",
    footer_tagline: "Air-powered tyre changing solutions for the Gulf region.",
    footer_quick_links: "Quick Links",
    footer_policies: "Policies",
    footer_warehouse: "Warehouse (JDL)",
    footer_follow_us: "Follow Us",
    footer_payments: "We Accept Secure Payments:",
    footer_rights: "All rights reserved.",
    policy_shipping: "Shipping",
    policy_warranty: "Warranty",
    policy_refund: "Refund",
    policy_privacy: "Privacy",

    // Contact
    contact_hero: "Get In Touch",
    contact_sub: "Have questions? We're here to help!",
    contact_info: "Contact Information",
    contact_email: "Email",
    contact_phone: "Phone",
    contact_warehouse: "Warehouse Address (JDL)",
    contact_person: "Contact Person",
    contact_code: "Warehouse Code",
    contact_hours: "Operating Hours",
    contact_view_map: "View on Google Maps",
    contact_form_title: "Send Us a Message",
    contact_form_sub: "Fill out the form below and we'll get back to you within 24 hours",
    contact_send: "Send Message",
    contact_name: "Full Name",
    contact_subject: "Subject",
    contact_message: "Message",
    contact_message_sent: "Message Sent!",
    contact_message_sent_desc: "Thank you for contacting us. We'll respond shortly.",

    // B2B
    b2b_hero: "Bulk Orders & Business Partnerships",
    b2b_sub: "Distributors, workshops, resellers & fleet operators",
    b2b_benefits_title: "Why Buy B2B from LCTX?",
    b2b_apply: "Submit B2B Enquiry",
    b2b_applying: "Submitting...",
    b2b_submitted: "Enquiry Submitted!",
    b2b_submitted_desc: "Our B2B team will contact you within 48 hours.",
    b2b_company: "Company Name *",
    b2b_contact_name: "Contact Person *",
    b2b_business_type: "Business Type *",
    b2b_volume: "Estimated Monthly Volume *",
    b2b_notes: "Message / Requirements",

    // Product price
    price_label: "USD",
    price_local_label: "Approx. local price",

    // HOME PAGE
    home_slogan: "LCTX Tyre changer, Easy Tyres change anywhere",
    home_reviews: "(247 reviews)",
    home_title: "LCTX Easy Tire Changer - Conquer Roadside Emergencies",
    home_subtitle: "Manual EZ Tire Changer - No Electricity Needed! Professional Air-Powered Tyre Changing Machine For Outdoor & Mobile Repairs",
    home_desc: "The LCTX portable pneumatic tire changer is a revolutionary air-powered tyre changing machine designed for professional mechanics and DIY enthusiasts. Change tyres anywhere without electricity - perfect for mobile tire service, roadside assistance, and home garages.",
    home_feat_torque_t: "2 Ton Torque",
    home_feat_torque_s: "No Electricity Needed",
    home_feat_time_t: "Time-Saving",
    home_feat_time_s: "Perfect for DIY",
    home_feat_prec_t: "Precision Engineering",
    home_feat_prec_s: "Accurate & Safe",
    home_feat_dur_t: "Durable Construction",
    home_feat_dur_s: "High-Strength Materials",
    home_save: "Save $200",
    home_instock: "In Stock - Ready to Ship + Free Worldwide Shipping",
    home_subscribe: "Subscribe on YouTube",
    home_trust_secure: "Secure checkout",
    home_trust_ships: "Ships within 24 hours",
    home_trust_warranty: "1-Year warranty",

    home_seo_heading: "About the LCTX Portable Tire Changer Machine",
    home_seo_p1: "The LCTX Air-Powered Tire Changer is a leading portable tyre changing solution for professional mechanics, mobile tire services, and automotive enthusiasts. Unlike traditional electric tire changers that require permanent installation and power outlets, the LCTX pneumatic tire changer operates entirely on compressed air, giving you the freedom to change tyres anywhere, anytime.",
    home_seo_h2_1: "Why Choose a Manual Easy Tire Changer?",
    home_seo_p2: "Traditional tire changing machines are heavy, expensive, and require electricity. The LCTX manual tire changer solves these problems with its innovative air-powered design. This easy tire changer weighs only 36kg (80 lbs), making it truly portable - you can transport it in your vehicle, set it up at any location with an air compressor, and start changing tyres within minutes.",
    home_seo_h2_2: "Professional-Grade Tyre Changing Power",
    home_seo_p3: "Don't let the compact size fool you - the LCTX tire changer delivers professional-grade performance with 2 tons of bead-breaking torque. It handles wheel sizes from 12\" to 21\" rim diameter, covering most passenger cars, SUVs, and light trucks. The pneumatic system provides smooth, controlled operation that protects wheels and tyres from damage during the changing process.",
    home_seo_h2_3: "Perfect for Mobile Mechanics & Roadside Assistance",
    home_seo_p4: "If you run a mobile tire service or roadside assistance business, the LCTX portable tire changer is a game-changer. No more turning away customers because you can't change their tyres on-site. With the LCTX tire changing machine, you bring professional tyre service directly to your customers' location.",
    home_seo_h2_4: "Tire Changer Features & Specifications",
    home_seo_li_1: "Air-Powered Operation: Requires 8-10 Bar (116-145 PSI) compressed air - no electricity needed",
    home_seo_li_2: "Wheel Size Range: Handles 12\" to 21\" rim diameter tyres",
    home_seo_li_3: "Maximum Wheel Diameter: 39 inches (1000mm)",
    home_seo_li_4: "Bead Breaker Force: 2000 kg (2 tons) of pneumatic power",
    home_seo_li_5: "Portable Weight: Only 36 kg (80 lbs) for easy transport",
    home_seo_li_6: "Setup Time: Ready to use in under 5 minutes",
    home_seo_li_7: "Construction: Heavy-duty steel frame with powder-coated finish",
    home_seo_h2_5: "How to Use the LCTX Tire Changer",
    home_seo_p5: "Using the LCTX portable tire changer is straightforward, even for beginners. Connect your air compressor, position the wheel on the mounting hub, use the pneumatic bead breaker to separate the tyre from the rim, then use the mounting/demounting head to remove and install tyres. Our video tutorials and user manual guide you through every step.",
    home_seo_h2_6: "Tire Changer Price & Value",
    home_seo_p6: "At $399 USD (regular price $699.99), the LCTX tire changer offers exceptional value compared to traditional electric tire changing machines that cost $2000-$5000+. Plus, you get free worldwide shipping and a 30-day money-back guarantee.",
    home_seo_h2_7: "Customer Reviews & Testimonials",
    home_seo_p7: "With over 500+ satisfied customers and a 4.8/5 star rating, the LCTX tire changer has become the go-to choice for mechanics and car enthusiasts. Customers praise its portability, ease of use, and professional-quality results.",
    home_seo_h2_8: "Free Worldwide Shipping",
    home_seo_p8: "We offer free standard shipping worldwide. Your LCTX tire changer will be carefully packaged and shipped within 24-48 hours of order confirmation. Delivery takes 5-10 business days to most countries.",
    home_seo_box_h: "Ready to start changing tyres anywhere?",
    home_seo_box_p: "Join 500+ professional mechanics and automotive enthusiasts worldwide who trust the LCTX portable tire changer for their tyre changing needs.",
    home_seo_box_btn: "View Full Tire Changer Specifications →",

    home_why_heading: "Why Choose LCTX TyreChanger?",
    home_why_sub: "Revolutionary tyre changing technology for professionals and DIY enthusiasts",
    home_card1_t: "Auto Shop",
    home_card1_d: "Professional tyre service operations",
    home_card2_t: "Roadside Rescue",
    home_card2_d: "Emergency tyre changes anywhere",
    home_card3_t: "Home Garage Friendly",
    home_card3_d: "Perfect for DIY enthusiasts",

    home_notice_title: "Important",
    home_notice_text: "This product requires an air compressor (not included) with minimum 8 Bar pressure and 8-10.5 gallon capacity.",

    home_faq_badge: "❓ GOT QUESTIONS?",
    home_faq_heading: "Frequently Asked Questions",
    home_faq_sub: "Everything you need to know about the LCTX Tyre Changer",
    home_faq1_q: "Does this tyre changer require electricity?",
    home_faq1_a: "No! The LCTX Tyre Changer is 100% air-powered. You only need an air compressor with minimum 8 Bar pressure. No electricity needed, making it perfect for mobile mechanics and outdoor use.",
    home_faq2_q: "What tyre sizes can it handle?",
    home_faq2_a: "The LCTX Tyre Changer can handle tyre sizes from 12\" to 21\" rim diameter. It's perfect for most passenger cars, SUVs, and light trucks.",
    home_faq3_q: "How portable is it really?",
    home_faq3_a: "At only 80 lbs (36 kg), it's truly portable! Unlike traditional tyre changers that weigh 300+ lbs and require permanent installation, the LCTX can be easily moved and stored when not in use.",
    home_faq4_q: "Is it suitable for professional use?",
    home_faq4_a: "Absolutely! With 2 tons of torque, the LCTX Tyre Changer is designed for both professional auto shops and DIY enthusiasts. Many mobile mechanics rely on it daily for roadside tyre changes.",
    home_faq5_q: "What's included in the package?",
    home_faq5_a: "Your package includes the LCTX Tyre Changer unit, all necessary mounting hardware, protective guards, a comprehensive user manual, and access to our video tutorials. Air compressor not included.",
    home_faq6_q: "How long does shipping take?",
    home_faq6_a: "We ship within 24-48 hours of order confirmation. Delivery takes 3-5 business days to major cities and 5-10 days to regional areas. Free shipping on all orders!",
    home_faq7_q: "What if I'm not satisfied with my purchase?",
    home_faq7_a: "We offer a 30-day money-back guarantee. If you're not completely satisfied, you can return it within 30 days for a full refund. Plus, every unit comes with a 1-year manufacturer's warranty.",
    home_faq8_q: "Do I need special training to use it?",
    home_faq8_a: "No special training required! The LCTX is designed to be user-friendly. We provide detailed video tutorials and a comprehensive manual. Most users are changing tyres confidently within 15 minutes of unboxing.",

    home_still_q: "Still Have Questions?",
    home_still_text: "Our team is here to help! Contact us anytime.",
    home_contact_support: "Contact Support",

    home_final_heading: "Ready To Transform Your Tyre Service Experience?",
    home_final_sub: "Join 500+ satisfied customers worldwide who've made the switch to LCTX",
    home_final_footer: "Free Worldwide Shipping • Secure checkout",

    // ABOUT PAGE
    about_badge: "LCTX Tyre changer, Easy Tyres change anywhere",
    about_hero_title: "About LCTX",
    about_hero_sub: "Pioneering portable tyre changing solutions",
    about_stat_founded: "Founded",
    about_stat_customers: "Customers",
    about_stat_rating: "Rating",
    about_story_heading: "Our Story",
    about_story_sub: "From a garage frustration to a revolutionary solution trusted by professionals worldwide",
    about_beg_badge: "2020 • THE BEGINNING",
    about_beg_title: "A Problem That Needed Solving",
    about_beg_p1: "LCTX TyreChanger was born out of frustration with traditional tyre changing methods. Our founder, Michael Chen, was working in his garage one weekend when he struggled with a particularly stubborn tyre. That's when he realized there had to be a better way.",
    about_beg_p2: "Traditional tyre changers were heavy, expensive, and required permanent installation with 220V power. Mobile mechanics and DIY enthusiasts needed something portable, powerful, and practical.",
    about_beg_img_t: "Innovation Starts Here",
    about_beg_img_s: "Professional engineering workspace",
    about_dev_badge: "2020-2021 • DEVELOPMENT",
    about_dev_title: "Engineering Excellence",
    about_dev_p1: "After months of research and development, we created the first air-powered, portable tyre changer that requires no electricity. Our revolutionary design uses compressed air to provide incredible torque and precision.",
    about_dev_p2: "The breakthrough came when we engineered a pneumatic system that delivered 2 tons of torque while weighing only 80 lbs - making it truly portable yet powerful enough for professional use.",
    about_dev_img_t: "Engineering Excellence",
    about_dev_img_s: "Precision manufacturing process",
    about_growth_badge: "2021-2024 • GROWTH",
    about_growth_title: "Trusted by Professionals Worldwide",
    about_growth_p1: "Today, our tyre changers are trusted by auto shops, roadside assistance professionals, and DIY enthusiasts around the world. We're proud to have helped thousands of people work smarter, not harder.",
    about_growth_p2: "From mobile mechanics serving remote areas to weekend warriors maintaining their own vehicles, LCTX has become the go-to solution for portable tyre changing.",
    about_growth_img_t: "500+ Happy Customers",
    about_growth_img_s: "Growing every day",
    about_commit_badge: "OUR COMMITMENT",
    about_commit_title: "Quality & Innovation",
    about_commit_p: "Every detail of the LCTX Tyre Changer reflects our commitment to quality, portability, and professional performance.",
    about_commit_li1: "No electricity required - pure pneumatic power",
    about_commit_li2: "Only 80 lbs - true portability",
    about_commit_li3: "2 ton torque - professional strength",
    about_commit_li4: "Handles 12-21\" tyres effortlessly",
    about_values_heading: "Our Core Values",
    about_values_sub: "The principles that guide everything we do",
    about_val1_t: "Innovation",
    about_val1_d: "We constantly push boundaries to create revolutionary solutions that solve real-world problems",
    about_val2_t: "Customer First",
    about_val2_d: "Every decision we make is centered around delivering exceptional value to our customers",
    about_val3_t: "Quality",
    about_val3_d: "We never compromise on quality, ensuring every product meets the highest standards",
    about_team_heading: "Meet Our Team",
    about_team_sub: "The passionate people behind LCTX",
    about_team_role1: "Founder & CEO",
    about_team_bio1: "Visionary engineer with 15+ years in automotive innovation",
    about_team_role2: "Chief Engineer",
    about_team_bio2: "Leading product development with expertise in pneumatic systems",
    about_team_role3: "Head of Operations",
    about_team_bio3: "Ensuring quality and customer satisfaction in every order",
    about_team_badge: "Team Member",
    about_team_years: "Years Exp.",
    about_team_projects: "Projects",
    about_join_heading: "Join Our Growing Team",
    about_join_p: "We're always looking for passionate individuals who want to revolutionize the tyre changing industry. If you're driven by innovation and excellence, we'd love to hear from you.",
    about_join_members: "Team Members",
    about_join_countries: "Countries",
    about_join_support: "Support",
    about_journey_heading: "Our Journey",
    about_journey_sub: "Milestones that shaped LCTX",
    about_ms1_t: "The Beginning",
    about_ms1_d: "Michael Chen founded LCTX with a vision to revolutionize tyre changing",
    about_ms2_t: "First Product Launch",
    about_ms2_d: "Released the first air-powered portable tyre changer to market",
    about_ms3_t: "100 Customers Milestone",
    about_ms3_d: "Reached our first 100 satisfied customers and expanded production",
    about_ms4_t: "500+ Happy Customers",
    about_ms4_d: "Growing community of auto professionals and DIY enthusiasts worldwide",

    // Arabic showcase
    home_arabic_showcase_title: "LCTX Tire Changer Highlights",
    home_arabic_showcase_sub: "Portable, air-powered, no electricity needed",

    // PRODUCT PAGE
    product_reviews: "(500+ reviews)",
    product_title: "LCTX Easy Tire Changer - Manual Air-Powered EZ Tyre Changing Machine",
    product_desc: "Professional manual tire changer - portable pneumatic EZ tire changing machine for roadside emergencies & mobile car repairs. No electricity needed - perfect for outdoor tyre service.",
    product_offer_title: "Special Offer",
    product_offer_text: "Save $200 + FREE Shipping",
    product_feat1_t: "12-21\" Tyres",
    product_feat1_s: "Handles Most Vehicles",
    product_feat2_t: "39\" Max Wheel",
    product_feat2_s: "Wide Compatibility",
    product_feat3_t: "Only 80 lbs",
    product_feat3_s: "True Portability",
    product_feat4_t: "2 Ton Torque",
    product_feat4_s: "Professional Power",
    product_save: "Save $200",
    product_local_approx: "Approx. local price",
    product_instock: "In Stock - Ready to Ship + Free Shipping",
    product_qty: "Quantity",
    product_total: "Total (incl. VAT)",
    product_buy_now: "Buy Now",
    product_subscribe: "Subscribe on YouTube",
    product_trust_ship: "Free Shipping",
    product_trust_back: "30-Day Money Back",
    product_trust_pay: "Secure Payment",
    product_notice_strong: "Important:",
    product_notice_text: "This product requires an air compressor with minimum 8 Bar pressure and 8-10.5 gallon capacity. Air compressor is not included.",
    product_video_badge: "VIDEO TUTORIALS",
    product_video_heading: "Complete Tire Changer Video Guides",
    product_video_sub: "Watch our step-by-step installation and usage tutorials",
    product_install_heading: "Installation Guide",
    product_install_box_t: "Step-by-Step Installation",
    product_install_box_p: "Learn how to install your LCTX portable tire changer in under 15 minutes:",
    product_install_s1: "Unboxing and parts identification",
    product_install_s2: "Assembling the bead breaker arm",
    product_install_s3: "Connecting pneumatic cylinders",
    product_install_s4: "Installing wheel hub assembly",
    product_install_s5: "Connecting air compressor (8-10 Bar)",
    product_install_s6: "Safety checks before first use",
    product_install_s7: "Testing all pneumatic functions",
    product_install_tip: "Pro Tip: Use thread-locking compound on mounting bolts. Ensure air compressor has 8-10.5 gallon capacity.",
    product_usage_heading: "How to Change Tires",
    product_usage_box_t: "Complete Tire Changing Process",
    product_usage_box_p: "Professional mechanic demonstrates complete tire changing with LCTX:",
    product_usage_s1_s: "Preparation", product_usage_s1_d: "Deflate tire, clean wheel, apply lubricant",
    product_usage_s2_s: "Breaking Bead", product_usage_s2_d: "Position arm, apply 2000kg force",
    product_usage_s3_s: "Removing Tire", product_usage_s3_d: "Mount wheel, lift beads over rim",
    product_usage_s4_s: "Installing Tire", product_usage_s4_d: "Position tire, work beads over rim",
    product_usage_s5_s: "Inflating", product_usage_s5_d: "Seat beads, inflate, balance wheel",
    product_usage_tip: "Always use quality tire lubricant. Work slowly to avoid rim damage.",
    product_usage_compat: "Compatible: 12-21\" wheels - cars, SUVs, light trucks, motorcycles (w/ adapter), ATVs.",
    product_video_cta: "Subscribe on YouTube",
    product_video_cta_sub: "Get notified of new tutorials and pro tips",
    product_tab_overview: "Overview",
    product_tab_specs: "Specifications",
    product_tab_faq: "FAQ",
    product_overview_h: "Why Choose LCTX?",
    product_overview_p1: "The LCTX Air-Powered Mini Tyre Changer is the perfect solution for mobile mechanics, DIY enthusiasts, and anyone who needs to change tyres on the go. No electricity required - just connect to your air compressor and you're ready to work!",
    product_overview_benefits: "Key Benefits:",
    product_benefit1: "Portable Design: At only 80 lbs, easily transport in your vehicle",
    product_benefit2: "No Electricity Needed: Works with any standard air compressor",
    product_benefit3: "Professional Power: 2 ton torque handles even the toughest tyres",
    product_benefit4: "Wide Compatibility: Works with 12-21\" rim sizes",
    product_benefit5: "Quick Setup: Ready to use in minutes",
    product_specs_h: "Technical Specifications",
    product_spec1_l: "Rim Diameter Range", product_spec1_v: '12" - 21"',
    product_spec2_l: "Max Wheel Diameter", product_spec2_v: '39" (1000mm)',
    product_spec3_l: "Operating Pressure", product_spec3_v: "8-10 Bar (116-145 PSI)",
    product_spec4_l: "Bead Breaker Force", product_spec4_v: "2000 kg (2 tons)",
    product_spec5_l: "Weight", product_spec5_v: "36 kg (80 lbs)",
    product_spec6_l: "Power Source", product_spec6_v: "Pneumatic (Air-Powered)",
    product_spec7_l: "Air Consumption", product_spec7_v: "8-10.5 gallon capacity required",
    product_spec8_l: "Dimensions", product_spec8_v: "Compact, portable design",
    product_faq1_q: "Do I need electricity to use this tyre changer?",
    product_faq1_a: "No! The LCTX is 100% air-powered. You only need an air compressor with 8-10 Bar pressure and 8-10.5 gallon capacity.",
    product_faq2_q: "What tyre sizes can it handle?",
    product_faq2_a: 'The LCTX can handle tyres from 12" to 21" rim diameter, covering most passenger cars, SUVs, and light trucks.',
    product_faq3_q: "Is it really portable?",
    product_faq3_a: "Yes! At only 80 lbs (36 kg), you can easily transport it in your vehicle. Perfect for mobile mechanics and roadside assistance.",
    product_faq4_q: "What's included in the package?",
    product_faq4_a: "You'll receive the complete tyre changer unit with all mounting hardware, protective guards, pry bar, and a comprehensive user manual.",
    product_faq5_q: "How long does shipping take?",
    product_faq5_a: "We ship within 24-48 hours. Delivery takes 3-5 business days to major cities and 5-10 days to regional areas.",
    product_parts_h: "What's Included - Parts List",
    product_parts_sub: "When you purchase the LCTX tyre changer, you'll receive two boxes with the following components:",
    product_part_1: "Hub Adjustment Assembly",
    product_part_2: "Large Cylinder and Foot Pedal Assembly",
    product_part_3: "Push Rod Assembly",
    product_part_4: "Bead Breaker Arm Assembly",
    product_part_5: "Cone for Securing the Wheel Hub Centre Hole",
    product_part_6: "Large Nut for Locking the Cone",
    product_part_7: "Wheel Hub Securing and Rotation Assembly",
    product_part_8: "Tyre Pry Bar",
    product_part_9: "Stabilising Stand for the Tyre Changer",
    product_part_10: "Bracket for Mounting the Large Cylinder",
    product_part_11: "Screws for Mounting the Bead Breaker Arm",
    product_part_12: "Screws for Mounting the Large Cylinder",
    product_part_13: "Hex Wrench",
    product_part_14: "Crescent Locking Wrench",
    product_parts_mobile: "View All 14 Parts (Tap to Expand)",
    product_parts_notice: "For UAE & Saudi Arabia Customers: Your LCTX tyre changer will arrive in two separate boxes. Please inspect both boxes upon delivery and verify all 14 components are present before installation.",
    product_guide_h: "Installation & Usage Guide",
    product_guide_sub: "Step-by-step instructions for using your LCTX Tyre Changer",
    product_guide_inst_h: "Installation Procedure",
    product_guide_inst_p: "Follow these steps to set up your LCTX Tyre Changer:",
    product_guide_inst_1: "Connect Air Supply: Attach your air compressor hose to the tyre changer's air inlet.",
    product_guide_inst_2: "Position the Unit: Place the tyre changer on a flat, stable surface.",
    product_guide_inst_3: "Adjust Height: Use the hub adjustment assembly to set the correct height for your wheel.",
    product_guide_inst_4: "Secure the Stand: Ensure the stabilising stand is properly positioned.",
    product_guide_inst_5: "Test Operation: Before working on a tyre, test all pneumatic functions.",
    product_guide_rem_h: "How to Remove a Tyre",
    product_guide_rem_1: "Deflate the Tyre: Remove the valve core and completely deflate the tyre.",
    product_guide_rem_2: "Break the Bead: Use the bead breaker arm to separate the tyre from the rim on both sides.",
    product_guide_rem_3: "Mount the Wheel: Secure the wheel on the hub using the locking cone.",
    product_guide_rem_4: "Lubricate: Apply tyre lubricant to both beads and the rim.",
    product_guide_rem_5: "Remove First Bead: Insert the pry bar and carefully work the first bead over the rim edge.",
    product_guide_rem_6: "Remove Second Bead: Repeat the process for the second bead.",
    product_guide_ins_h: "How to Install a Tyre",
    product_guide_ins_1: "Inspect the Tyre: Check the new tyre for any damage or defects.",
    product_guide_ins_2: "Lubricate: Apply generous amounts of tyre lubricant to both beads.",
    product_guide_ins_3: "Position First Bead: Place the first bead over the rim and work it down using the pry bar.",
    product_guide_ins_4: "Install Second Bead: Carefully work the second bead over the rim edge.",
    product_guide_ins_5: "Inflate: Slowly inflate the tyre, ensuring both beads seat properly on the rim.",
    product_guide_ins_6: "Balance: Check the tyre balance and make necessary adjustments.",
    product_guide_ins_7: "Final Check: Inspect the installation and check tyre pressure.",
    product_manual_h: "Download Complete User Manual",
    product_manual_p: "Get the comprehensive PDF guide with detailed instructions, diagrams, safety information, and troubleshooting tips for your LCTX Tyre Changer.",
    product_manual_btn: "Download PDF Manual",
    product_manual_meta: "File size: 2.5 MB • Format: PDF • Language: English",
    product_final_h: "Ready To Order?",
    product_final_sub: "Get your LCTX Tyre Changer delivered to your door",
    product_final_footer: "Free Worldwide Shipping • 30-Day Money-Back Guarantee",

    // HOW TO USE PAGE
    htu_srh1: "How to Use the LCTX Tire Changer - Complete Step-by-Step Guide",
    htu_hero_badge: "OFFICIAL LCTX GUIDE",
    htu_hero_title: "How to Use the LCTX Tire Changer",
    htu_hero_sub: "Complete Step-by-Step Guide for Professional Tire Changing",
    htu_intro_p1: "The ",
    htu_intro_p2: "LCTX Tire Changer",
    htu_intro_p3: " is designed for efficient, portable tire service. Follow this complete process to successfully remove an old tire and install a new one. This guide covers the entire tire changing process from bead breaking to final installation.",
    htu_alert_strong: "Before You Start:",
    htu_alert_text: " Ensure your air compressor is connected and provides minimum 8 Bar (116 PSI) pressure. Wear safety glasses and gloves throughout the process.",
    htu_video_h: "Official Video Tutorial",
    htu_video_sub: "Watch the complete demonstration",
    htu_phase1_title: "Phase 1: Removing the Old Tire (Demounting)",
    htu_phase1_sub: "Follow these steps to safely remove the old tire from the rim",
    htu_p1_s1_h: "Step 1: Break the Bead",
    htu_p1_s1_p1: "Use the built-in ",
    htu_p1_s1_p2: "bead breaker",
    htu_p1_s1_p3: " on the side of the machine to separate the tire's bead from the rim's edge. Position the bead breaker arm against the tire sidewall near the rim edge. Apply pneumatic pressure using the foot pedal to push the bead away from the rim. This breaks the seal that holds the tire to the wheel. Repeat this process on both sides of the tire (top and bottom beads).",
    htu_p1_s2_h: "Step 2: Lubricate",
    htu_p1_s2_p1: "Apply ",
    htu_p1_s2_p2: "tire lubricant or soapy water",
    htu_p1_s2_p3: " generously to the outside of the tire bead and the edge of the rim. This lubrication is crucial - it reduces friction and prevents damage to both the tire and rim during removal. Use a brush or spray bottle to ensure even coverage around the entire bead circumference.",
    htu_p1_s3_h: "Step 3: Mount the Wheel Securely",
    htu_p1_s3_p1: "Place the wheel onto the machine's ",
    htu_p1_s3_p2: "center post",
    htu_p1_s3_p3: ", ensuring it is secured tightly using the locking cone and nut. The wheel should sit flat and stable on the mounting table. Reposition the tire so the ",
    htu_p1_s3_p4: "valve stem is located in front of the operator",
    htu_p1_s3_p5: " - this makes it easier to work with and prevents damage to the valve during the tire changing process.",
    htu_p1_s4_h: "Step 4: Position the Mounting Head (Duck Head)",
    htu_p1_s4_p1: "Adjust the machine's ",
    htu_p1_s4_p2: "mounting head",
    htu_p1_s4_p3: " (often called the \"duck head\") against the rim's edge. Make sure it is aligned correctly to guide the bead smoothly over the rim without scratching or damaging the wheel finish. The mounting head should be positioned just inside the rim's outer edge.",
    htu_p1_s5_h: "Step 5: Pry the Bead",
    htu_p1_s5_p1: "Insert a ",
    htu_p1_s5_p2: "tire iron",
    htu_p1_s5_p3: " (pry bar) under the upper tire bead, positioning the bar just behind the mounting head. Use the tire iron to lift the bead up and over the mounting head. This initial prying action starts the process of working the tire off the rim.",
    htu_p1_s6_h: "Step 6: Rotate the Wheel",
    htu_p1_s6_p1: "Engage the machine's ",
    htu_p1_s6_p2: "rotation mechanism",
    htu_p1_s6_p3: " using the foot pedal or hand crank. As the wheel rotates, maintain pressure on the tire iron to keep the bead lifted. The combination of the mounting head and tire iron leverage will progressively work the tire bead up and over the rim edge. Continue rotating until the entire upper bead is removed.",
    htu_p1_s7_h: "Step 7: Remove the Second Bead",
    htu_p1_s7_p: "Once the upper bead is off, flip the wheel over and repeat the prying and rotation process to remove the lower (inside) bead. Position the mounting head, insert the tire iron, and rotate the wheel until the old tire is fully detached from the rim. Remove the completely dismounted tire from the wheel.",
    htu_phase2_title: "Phase 2: Installing the New Tire (Mounting)",
    htu_phase2_sub: "Follow these steps to properly mount your new tire",
    htu_p2_s1_h: "Step 1: Lubricate Again",
    htu_p2_s1_p1: "Apply ",
    htu_p2_s1_p2: "additional lubricant",
    htu_p2_s1_p3: " to the new tire's beads (both upper and lower) and the clean rim edges. Proper lubrication is even more critical during installation to prevent tire damage and ensure smooth bead seating. Don't skimp on lubricant - use plenty around the entire circumference.",
    htu_p2_s2_h: "Step 2: Position the Tire",
    htu_p2_s2_p: "Place the new tire onto the rim, resting it on the machine's mounting table. Make sure the tire rotation direction marking (if present) matches the wheel's intended rotation direction. Align the tire so it sits evenly on the rim.",
    htu_p2_s3_h: "Step 3: Mount the First Bead",
    htu_p2_s3_p1: "Use the ",
    htu_p2_s3_p2: "mounting head",
    htu_p2_s3_p3: " to press the first (lower) bead of the new tire onto the rim. Position the mounting head against the tire bead and rotate the wheel. The mounting head will guide the bead over the rim edge and into the rim's drop center.",
    htu_p2_s4_h: "Step 4: Leverage and Press",
    htu_p2_s4_p1: "Apply ",
    htu_p2_s4_p2: "downward pressure",
    htu_p2_s4_p3: " on the opposite side of the tire (the side opposite to the mounting head). You can use a helper arm, your foot, or a pressing tool to push the tire down into the rim's drop center. This creates necessary slack on the side where you're working, making it much easier to get the final bead over the rim.",
    htu_p2_s5_h: "Step 5: Complete Installation",
    htu_p2_s5_p1: "Engage the ",
    htu_p2_s5_p2: "rotation mechanism",
    htu_p2_s5_p3: " again, allowing the mounting head to smoothly press the final (upper) bead over the rim edge. Continue rotating until the entire tire is seated on the rim. Once complete, install the valve core and inflate the tire to the recommended pressure. Check that both beads are properly seated on the rim before removing the wheel from the machine.",
    htu_safety_h: "Important Safety Tips",
    htu_safety_1_1: "Always wear safety glasses",
    htu_safety_1_2: " - tire beads can snap and cause injury",
    htu_safety_2_1: "Use proper lubrication",
    htu_safety_2_2: " - never force a dry tire onto a rim",
    htu_safety_3_1: "Check air compressor pressure",
    htu_safety_3_2: " - maintain 8-10 Bar (116-145 PSI)",
    htu_safety_4_1: "Inspect tires before mounting",
    htu_safety_4_2: " - look for damage or defects",
    htu_safety_5_1: "Never exceed recommended inflation pressure",
    htu_safety_5_2: " during bead seating",
    htu_cta_h: "Ready to Get Your LCTX Tire Changer?",
    htu_cta_sub: "Start changing tires anywhere with our portable air-powered solution",
    htu_cta_btn1: "View Product Details",
    htu_cta_btn2: "Watch More Tutorials",
    htu_cta_footer: "✅ FREE Shipping • ✅ 30-Day Warranty • ✅ Best Price",
  },
  ar: {
    // Brand / generic
    tagline: "تغيير الإطارات بسهولة في أي مكان",
    order_now: "اطلب الآن",
    buy_now: "اشترِ الآن",
    back: "رجوع",
    free_shipping: "شحن مجاني",
    secure_payment: "دفع آمن",
    money_back: "استرداد خلال 30 يومًا",
    in_stock: "متوفر · جاهز للشحن + شحن مجاني",
    usd: "دولار أمريكي",
    total: "الإجمالي (شامل الضريبة)",
    quantity: "الكمية",
    special_offer: "عرض خاص",
    save_shipping: "وفّر 200$ + شحن مجاني",
    cod_payment: "الدفع عند الاستلام (COD)",

    // Nav
    nav_home: "الرئيسية",
    nav_product: "المنتج",
    nav_how_to_use: "طريقة الاستخدام",
    nav_about: "من نحن",
    nav_blog: "المدونة",
    nav_b2b: "الأعمال",
    nav_contact: "تواصل معنا",
    nav_track_order: "تتبع الطلب",

    // Track Order
    track_hero: "تتبع طلبك",
    track_sub: "أدخل رقم الطلب للاطلاع على حالة توصيل جهاز تغيير الإطارات LCTX.",
    track_search_ph: "أدخل رقم الطلب",
    track_btn: "تتبع الطلب",
    track_loading: "جارٍ البحث عن طلبك...",
    track_notfound: "تعذر العثور على طلب بهذا الرقم. يرجى التحقق والمحاولة مرة أخرى.",
    track_err: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    track_order_id_label: "رقم الطلب",
    track_order_date: "تاريخ الطلب",
    track_qty: "الكمية",
    track_total: "الإجمالي",
    track_dest: "الشحن إلى",
    track_payment: "الدفع",
    track_placed: "تم استلام الطلب",
    track_placed_desc: "لقد استلمنا طلبك.",
    track_confirmed: "تم التأكيد",
    track_confirmed_desc: "تم تأكيد طلبك وجارٍ تجهيزه.",
    track_shipped: "تم الشحن",
    track_shipped_desc: "جهاز تغيير الإطارات في طريقه إليك.",
    track_delivered: "تم التسليم",
    track_delivered_desc: "وصل طلبك. استمتع بجهاز LCTX!",
    track_cancelled: "تم إلغاء الطلب",
    track_cancelled_desc: "تم إلغاء هذا الطلب.",
    track_paid: "مدفوع",
    track_unpaid: "بانتظار الدفع",

    // Footer
    footer_company: "إل سي تي إكس",
    footer_tagline: "حلول تغيير الإطارات بالهواء المضغوط لمنطقة الخليج.",
    footer_quick_links: "روابط سريعة",
    footer_policies: "السياسات",
    footer_warehouse: "المستودع (JDL)",
    footer_follow_us: "تابعنا",
    footer_payments: "طرق الدفع الآمنة:",
    footer_rights: "جميع الحقوق محفوظة.",
    policy_shipping: "الشحن",
    policy_warranty: "الضمان",
    policy_refund: "الاسترداد",
    policy_privacy: "الخصوصية",

    // Contact
    contact_hero: "تواصل معنا",
    contact_sub: "هل لديك أسئلة؟ نحن هنا للمساعدة!",
    contact_info: "معلومات التواصل",
    contact_email: "البريد الإلكتروني",
    contact_phone: "الهاتف",
    contact_warehouse: "عنوان المستودع (JDL)",
    contact_person: "مسؤول التواصل",
    contact_code: "رمز المستودع",
    contact_hours: "ساعات العمل",
    contact_view_map: "عرض على خرائط جوجل",
    contact_form_title: "أرسل لنا رسالة",
    contact_form_sub: "املأ النموذج وسنعاود التواصل معك خلال 24 ساعة",
    contact_send: "إرسال الرسالة",
    contact_name: "الاسم الكامل",
    contact_subject: "الموضوع",
    contact_message: "الرسالة",
    contact_message_sent: "تم إرسال الرسالة!",
    contact_message_sent_desc: "شكرًا لتواصلك معنا. سيرد فريقنا قريبًا.",

    // B2B
    b2b_hero: "طلبات الجملة وشراكات الأعمال",
    b2b_sub: "للموزعين والورش وإعادة البائعين ومشغلي الأساطيل",
    b2b_benefits_title: "لماذا الشراء B2B من LCTX؟",
    b2b_apply: "إرسال طلب الأعمال",
    b2b_applying: "جارٍ الإرسال...",
    b2b_submitted: "تم إرسال الطلب!",
    b2b_submitted_desc: "سيتواصل معك فريق الأعمال خلال 48 ساعة.",
    b2b_company: "اسم الشركة *",
    b2b_contact_name: "مسؤول التواصل *",
    b2b_business_type: "نوع النشاط *",
    b2b_volume: "الحجم الشهري المقدّر *",
    b2b_notes: "رسالة / المتطلبات",

    // Product price
    price_label: "دولار أمريكي",
    price_local_label: "السعر المحلي التقريبي",

    // HOME PAGE
    home_slogan: "مبدّل إطارات LCTX، تغيير الإطارات بسهولة في أي مكان",
    home_reviews: "(247 مراجعة)",
    home_title: "مبدّل إطارات LCTX السهل — واجه طوارئ الطريق بثقة",
    home_subtitle: "مبدّل إطارات يدوي سهز — لا يحتاج كهرباء! آلة تغيير إطارات احترافية تعمل بالهواء المضغوط للإصلاحات الخارجية والمتنقلة",
    home_desc: "مبدّل الإطارات الهوائي المحمول من LCTX هو آلة تغيير إطارات ثورية تعمل بالهواء المضغوط ومصممة للميكانيكيين المحترفين وهواة الأعمال اليدوية. غيّر الإطارات في أي مكان دون كهرباء — مثالي لخدمات الإطارات المتنقلة والمساعدة على الطريق ومرائب المنازل.",
    home_feat_torque_t: "عزم 2 طن",
    home_feat_torque_s: "بدون كهرباء",
    home_feat_time_t: "توفير للوقت",
    home_feat_time_s: "مثالي للأعمال اليدوية",
    home_feat_prec_t: "هندسة دقيقة",
    home_feat_prec_s: "دقيق وآمن",
    home_feat_dur_t: "بناء متين",
    home_feat_dur_s: "مواد عالية القوة",
    home_save: "وفّر 200$",
    home_instock: "متوفر — جاهز للشحن + شحن مجاني حول العالم",
    home_subscribe: "اشترك على يوتيوب",
    home_trust_secure: "دفع آمن",
    home_trust_ships: "يُشحن خلال 24 ساعة",
    home_trust_warranty: "ضمان سنة واحدة",

    home_seo_heading: "حول آلة تغيير الإطارات المحمولة من LCTX",
    home_seo_p1: "مبدّل الإطارات الهوائي من LCTX هو حل محمول رائد ل changing الإطارات للميكانيكيين المحترفين وخدمات الإطارات المتنقلة وعشاق السيارات. على عكس مبدّلات الإطارات الكهربائية التقليدية التي تتطلب تركيبًا دائمًا ومصادر طاقة، يعمل مبدّل LCTX الهوائي بالكامل على الهواء المضغوط، مما يمنحك حرية تغيير الإطارات في أي مكان وفي أي وقت.",
    home_seo_h2_1: "لماذا تختار مبدّل الإطارات اليدوي السهل؟",
    home_seo_p2: "آلات تغيير الإطارات التقليدية ثقيلة ومكلفة وتحتاج كهرباء. يحل مبدّل LCTX اليدوي هذه المشكلات بتصميمه الهوائي المبتكر. يزن هذا المبدّل السهل 36 كجم فقط (80 رطلاً)، مما يجعله محمولاً حقًا — يمكنك نقله في سيارتك وتشغيله في أي مكان به كمبروسر هواء والبدء بتغيير الإطارات خلال دقائق.",
    home_seo_h2_2: "قوة تغيير إطارات بمستوى احترافي",
    home_seo_p3: "لا تدع الحجم المدمع يخدعك — يقدّم مبدّل LCTX أداءً احترافيًا بعزم كسر خرزة قدره 2 طن. يتعامل مع مقاسات عجلات من 12\" إلى 21\" قطر النسم، ويغطي معظم سيارات الركاب وسيارات الدفع الرباعي والشاحنات الخفيفة. يوفّر النظام الهوائي تشغيلًا سلسًا ومتحكمًا به يحمي العجلات والإطارات من التلف أثناء التغيير.",
    home_seo_h2_3: "مثالي للميكانيكيين المتنقلين والمساعدة على الطريق",
    home_seo_p4: "إذا كنت تدير خدمة إطارات متنقلة أو عمل مساعدة على الطريق، فإن مبدّل الإطارات المحمول من LCTX نقلة نوعية. لا مزيد من رفض العملاء لأنك لا تستطيع تغيير إطاراتهم في موقعهم. مع آلة تغيير الإطارات من LCTX، تحضر خدمة الإطارات الاحترافية مباشرة إلى موقع عميلك.",
    home_seo_h2_4: "مميزات ومواصفات مبدّل الإطارات",
    home_seo_li_1: "تشغيل بالهواء المضغوط: يتطلب هواءً مضغوطًا بضغط 8-10 بار (116-145 PSI) — بدون كهرباء",
    home_seo_li_2: "نطاق مقاسات العجلات: يتعامل مع إطارات قطر نسم من 12\" إلى 21\"",
    home_seo_li_3: "أقصى قطر للعجلة: 39 بوصة (1000 ملم)",
    home_seo_li_4: "قوة كسر الخرزة: 2000 كجم (2 طن) من القوة الهوائية",
    home_seo_li_5: "وزن محمول: 36 كجم فقط (80 رطلاً) لنقل سهل",
    home_seo_li_6: "وقت التجهيز: جاهز للاستخدام في أقل من 5 دقائق",
    home_seo_li_7: "البناء: إطار فولاذي ثقيل بطلاء مطحون بالبودرة",
    home_seo_h2_5: "كيفية استخدام مبدّل إطارات LCTX",
    home_seo_p5: "استخدام مبدّل الإطارات المحمول من LCTX سهل حتى للمبتدئين. صل كمبروسر الهواء، ضع العجلة على المحور، استخدم كسّر الخرزة الهوائي لفصل الإطارة عن النسم، ثم استخدم رأس التركيب/الفك لإزالة وتركيب الإطارات. ترشدك دروس الفيديو ودليل المستخدم خلال كل خطوة.",
    home_seo_h2_6: "سعر وقيمة مبدّل الإطارات",
    home_seo_p6: "بسعر 399$ دولار أمريكي (السعر العادي 699.99$)، يقدّم مبدّل LCTX قيمة استثنائية مقارنة بآلات تغيير الإطارات الكهربائية التقليدية التي تكلف 2000-5000$+. بالإضافة إلى ذلك، تحصل على شحن مجاني حول العالم وضمان استرداد خلال 30 يومًا.",
    home_seo_h2_7: "مراجعات وآراء العملاء",
    home_seo_p7: "مع أكثر من 500+ عميل راضٍ وتقييم 4.8/5 نجوم، أصبح مبدّل إطارات LCTX الخيار الأول للميكانيكيين وعشاق السيارات. يمدح العملاء قابلية النقل وسهولة الاستخدام وجودة النتائج الاحترافية.",
    home_seo_h2_8: "شحن مجاني حول العالم",
    home_seo_p8: "نقدّم شحنًا قياسيًا مجانيًا حول العالم. سيتم تغليف مبدّل إطارات LCTX بعناية وشحنه خلال 24-48 ساعة من تأكيد الطلب. التوصيل يستغرق 5-10 أيام عمل لمعظم الدول.",
    home_seo_box_h: "جاهز لبدء تغيير الإطارات في أي مكان؟",
    home_seo_box_p: "انضم إلى أكثر من 500+ ميكانيكي محترف وعشاق سيارات حول العالم يثقون بمبدّل الإطارات المحمول من LCTX لاحتياجاتهم.",
    home_seo_box_btn: "عرض المواصفات الكاملة لمبدّل الإطارات ←",

    home_why_heading: "لماذا تختار مبدّل إطارات LCTX؟",
    home_why_sub: "تقنية تغيير إطارات ثورية للمحترفين وهواة الأعمال اليدوية",
    home_card1_t: "ورشة السيارات",
    home_card1_d: "عمليات خدمة إطارات احترافية",
    home_card2_t: "إنقاذ على الطريق",
    home_card2_d: "تغيير إطارات طارئ في أي مكان",
    home_card3_t: "مناسب لمرائب المنازل",
    home_card3_d: "مثالي لهواة الأعمال اليدوية",

    home_notice_title: "تنبيه",
    home_notice_text: "يتطلب هذا المنتج كمبروسر هواء (غير مُضمّن) بضغط لا يقل عن 8 بار وسعة 8-10.5 جالون.",

    home_faq_badge: "❓ لديك أسئلة؟",
    home_faq_heading: "الأسئلة الشائعة",
    home_faq_sub: "كل ما تحتاج معرفته عن مبدّل إطارات LCTX",
    home_faq1_q: "هل يحتاج مبدّل الإطارات هذا إلى كهرباء؟",
    home_faq1_a: "لا! مبدّل إطارات LCTX يعمل بالهواء المضغوط 100%. تحتاج فقط كمبروسر هواء بضغط لا يقل عن 8 بار. لا حاجة للكهرباء، مما يجعله مثاليًا للميكانيكيين المتنقلين والاستخدام الخارجي.",
    home_faq2_q: "ما مقاسات الإطارات التي يتعامل معها؟",
    home_faq2_a: "يتعامل مبدّل إطارات LCTX مع مقاسات إطارات قطر نسم من 12\" إلى 21\". وهو مثالي لمعظم سيارات الركاب وسيارات الدفع الرباعي والشاحنات الخفيفة.",
    home_faq3_q: "ما مدى قابلية النقل فعليًا؟",
    home_faq3_a: "بوزن 80 رطلاً فقط (36 كجم)، فهو محمول حقًا! على عكس مبدّلات الإطارات التقليدية التي تزن 300+ رطل وتتطلب تركيبًا دائمًا، يمكن نقل LCTX وتخزينه بسهولة عند عدم الاستخدام.",
    home_faq4_q: "هل هو مناسب للاستخدام الاحترافي؟",
    home_faq4_a: "بالتأكيد! بعزم 2 طن، صُمم مبدّل إطارات LCTX للورش الاحترافية وهواة الأعمال اليدوية معًا. يعتمد عليه الكثير من الميكانيكيين المتنقلين يوميًا لتغيير الإطارات على الطريق.",
    home_faq5_q: "ما الذي يحتويه الطرد؟",
    home_faq5_a: "يحتوي طردك على وحدة مبدّل إطارات LCTX، وكل معدات التركيب اللازمة، والأغطية الواقية، ودليل مستخدم شامل، والوصول إلى دروس الفيديو الخاصة بنا. لا يشمل كمبروسر الهواء.",
    home_faq6_q: "كم يستغرق الشحن؟",
    home_faq6_a: "نشحن خلال 24-48 ساعة من تأكيد الطلب. يستغرق التوصيل 3-5 أيام عمل للمدن الكبرى و5-10 أيام للمناطق النائية. شحن مجاني لجميع الطلبات!",
    home_faq7_q: "ماذا لو لم أكن راضيًا عن مشتراتي؟",
    home_faq7_a: "نقدّم ضمان استرداد خلال 30 يومًا. إذا لم تكن راضيًا تمامًا، يمكنك إعادته خلال 30 يومًا لاسترداد كامل. بالإضافة إلى ذلك، تأتي كل وحدة بضمان المصنع لمدة سنة واحدة.",
    home_faq8_q: "هل أحتاج إلى تدريب خاص لاستخدامه؟",
    home_faq8_a: "لا حاجة لتدريب خاص! صُمم LCTX ليكون سهل الاستخدام. نقدّم دروس فيديو مفصلة ودليلًا شاملاً. معظم المستخدمين يغيّرون الإطارات بثقة خلال 15 دقيقة من فتح العلبة.",

    home_still_q: "ما زالت لديك أسئلة؟",
    home_still_text: "فريقنا هنا للمساعدة! تواصل معنا في أي وقت.",
    home_contact_support: "تواصل مع الدعم",

    home_final_heading: "جاهز لتغيير تجربة خدمة الإطارات لديك؟",
    home_final_sub: "انضم إلى أكثر من 500+ عميل راضٍ حول العالم اختاروا LCTX",
    home_final_footer: "شحن مجاني حول العالم • دفع آمن",

    // ABOUT PAGE
    about_badge: "مبدّل إطارات LCTX، تغيير الإطارات بسهولة في أي مكان",
    about_hero_title: "عن LCTX",
    about_hero_sub: "روّاد حلول تغيير الإطارات المحمولة",
    about_stat_founded: "التأسيس",
    about_stat_customers: "العملاء",
    about_stat_rating: "التقييم",
    about_story_heading: "قصتنا",
    about_story_sub: "من إحباط في المرآب إلى حل ثوري يثق به المحترفون حول العالم",
    about_beg_badge: "2020 • البداية",
    about_beg_title: "مشكلة كانت بحاجة لحل",
    about_beg_p1: "وُلد مبدّل إطارات LCTX من الإحباط من طرق تغيير الإطارات التقليدية. مؤسسنا، مايكل تشن، كان يعمل في مرآبه ذات عطلة نهاية أسبوع عندما كافح مع إطارة عنيدة بشكل خاص. حينها أدرك أنه لا بد من طريقة أفضل.",
    about_beg_p2: "كانت مبدّلات الإطارات التقليدية ثقيلة ومكلفة وتتطلب تركيبًا دائمًا بطاقة 220 فولت. كان الميكانيكيون المتنقلون وهواة الأعمال اليدوية بحاجة إلى شيء محمول وقوي وعملي.",
    about_beg_img_t: "هنا تبدأ الابتكار",
    about_beg_img_s: "مساحة هندسة احترافية",
    about_dev_badge: "2020-2021 • التطوير",
    about_dev_title: "تميّز هندسي",
    about_dev_p1: "بعد أشهر من البحث والتطوير، أنشأنا أول مبدّل إطارات محمول يعمل بالهواء المضغوط ولا يحتاج كهرباء. تصميمنا الثوري يستخدم الهواء المضغوط لتوفير عزم ودقة لا تصدق.",
    about_dev_p2: "جاء الاختراق عندما صمّمنا نظامًا هوائيًا يقدّم عزمًا قدره 2 طن بوزن 80 رطلاً فقط — مما يجعله محمولاً حقًا وقويًا بما يكفي للاستخدام الاحترافي.",
    about_dev_img_t: "تميّز هندسي",
    about_dev_img_s: "عملية تصنيع دقيقة",
    about_growth_badge: "2021-2024 • النمو",
    about_growth_title: "موثوق به من المحترفين حول العالم",
    about_growth_p1: "اليوم، يثق بمبدّلات إطاراتنا ورش السيارات ومحترفو المساعدة على الطريق وهواة الأعمال اليدوية حول العالم. نحن فخورون بمساعدة آلاف الأشخاص على العمل بذكاء أكبر لا بجهد أكبر.",
    about_growth_p2: "من الميكانيكيين المتنقلين الذين يخدمون المناطق النائية إلى هواة عطلة النهاية الذين يصونون سياراتهم، أصبح LCTX الحل الأمثل لتغيير الإطارات المحمول.",
    about_growth_img_t: "أكثر من 500+ عميل سعيد",
    about_growth_img_s: "ينمو كل يوم",
    about_commit_badge: "التزامنا",
    about_commit_title: "الجودة والابتكار",
    about_commit_p: "كل تفصيلة في مبدّل إطارات LCTX تعكس التزامنا بالجودة وقابلية النقل والأداء الاحترافي.",
    about_commit_li1: "بدون كهرباء — قوة هوائية نقيّة",
    about_commit_li2: "80 رطلاً فقط — قابلية نقل حقيقية",
    about_commit_li3: "عزم 2 طن — قوة احترافية",
    about_commit_li4: "يتعامل مع إطارات 12-21\" بسهولة",
    about_values_heading: "قيمنا الأساسية",
    about_values_sub: "المبادئ التي توجّه كل ما نقوم به",
    about_val1_t: "الابتكار",
    about_val1_d: "ندفع الحدود باستمرار لخلق حلول ثورية تحل مشكلات حقيقية",
    about_val2_t: "العميل أولاً",
    about_val2_d: "كل قرار نتخذه يتمحور حول تقديم قيمة استثنائية لعملائنا",
    about_val3_t: "الجودة",
    about_val3_d: "لا نساوم أبدًا على الجودة، ونضمن أن كل منتج يلبي أعلى المعايير",
    about_team_heading: "تعرّف على فريقنا",
    about_team_sub: "الأشخاص المتحمسون خلف LCTX",
    about_team_role1: "المؤسس والرئيس التنفيذي",
    about_team_bio1: "مهندس رؤيوي بخبرة أكثر من 15 عامًا في ابتكار السيارات",
    about_team_role2: "كبير المهندسين",
    about_team_bio2: "يقود تطوير المنتج بخبرة في الأنظمة الهوائية",
    about_team_role3: "رئيس العمليات",
    about_team_bio3: "يضمن الجودة ورضا العملاء في كل طلب",
    about_team_badge: "عضو فريق",
    about_team_years: "سنوات خبرة",
    about_team_projects: "مشاريع",
    about_join_heading: "انضم إلى فريقنا المتنامي",
    about_join_p: "نبحث دائمًا عن أفراد متحمسين يرغبون في إحداث ثورة في صناعة تغيير الإطارات. إذا كنت مدفوعًا بالابتكار والتميّز، يسعدنا أن نسمع منك.",
    about_join_members: "أعضاء الفريق",
    about_join_countries: "دول",
    about_join_support: "دعم",
    about_journey_heading: "رحلتنا",
    about_journey_sub: "محطات صنعت LCTX",
    about_ms1_t: "البداية",
    about_ms1_d: "أسس مايكل تشن LCTX برؤية لإحداث ثورة في تغيير الإطارات",
    about_ms2_t: "إطلاق أول منتج",
    about_ms2_d: "أطلقنا أول مبدّل إطارات محمول يعمل بالهواء المضغوط في السوق",
    about_ms3_t: "علامة 100 عميل",
    about_ms3_d: "وصلنا إلى أول 100 عميل راضٍ ووسّعنا الإنتاج",
    about_ms4_t: "أكثر من 500+ عميل سعيد",
    about_ms4_d: "مجتمع متنامٍ من محترفي السيارات وهواة الأعمال اليدوية حول العالم",

    // Arabic showcase
    home_arabic_showcase_title: "مزايا جهاز LCTX لتغيير الإطارات",
    home_arabic_showcase_sub: "محمول، يعمل بالهواء، بدون كهرباء",

    // PRODUCT PAGE
    product_reviews: "(أكثر من 500 مراجعة)",
    product_title: "مبدّل إطارات LCTX السهل — آلة تغيير إطارات يدوية تعمل بالهواء",
    product_desc: "مبدّل إطارات يدوي احترافي — آلة تغيير إطارات محمولة تعمل بالهواء لحالات الطوارئ على الطريق والإصلاحات المتنقلة. لا يحتاج كهرباء — مثالي لخدمة الإطارات في الخارج.",
    product_offer_title: "عرض خاص",
    product_offer_text: "وفّر 200$ + شحن مجاني",
    product_feat1_t: 'إطارات 12-21"',
    product_feat1_s: "يتعامل مع معظم المركبات",
    product_feat2_t: 'عجلة حتى 39"',
    product_feat2_s: "توافق واسع",
    product_feat3_t: "80 رطلاً فقط",
    product_feat3_s: "قابلية نقل حقيقية",
    product_feat4_t: "عزم 2 طن",
    product_feat4_s: "قوة احترافية",
    product_save: "وفّر 200$",
    product_local_approx: "السعر المحلي التقريبي",
    product_instock: "متوفر — جاهز للشحن + شحن مجاني",
    product_qty: "الكمية",
    product_total: "الإجمالي (شامل الضريبة)",
    product_buy_now: "اشترِ الآن",
    product_subscribe: "اشترك على يوتيوب",
    product_trust_ship: "شحن مجاني",
    product_trust_back: "استرداد خلال 30 يومًا",
    product_trust_pay: "دفع آمن",
    product_notice_strong: "تنبيه:",
    product_notice_text: "يتطلب هذا المنتج كمبروسر هواء (غير مُضمّن) بضغط لا يقل عن 8 بار وسعة 8-10.5 جالون.",
    product_video_badge: "دروس فيديو",
    product_video_heading: "أدلة فيديو كاملة لمبدّل الإطارات",
    product_video_sub: "شاهد دروس التركيب والاستخدام خطوة بخطوة",
    product_install_heading: "دليل التركيب",
    product_install_box_t: "تركيب خطوة بخطوة",
    product_install_box_p: "تعلّم كيفية تركيب مبدّل الإطارات المحمول من LCTX في أقل من 15 دقيقة:",
    product_install_s1: "فتح العلبة وتحديد القطع",
    product_install_s2: "تجميع ذراع كسر الخرزة",
    product_install_s3: "توصيل الأسطوانات الهوائية",
    product_install_s4: "تركيب مجموعة محور العجلة",
    product_install_s5: "توصيل كمبروسر الهواء (8-10 بار)",
    product_install_s6: "فحوصات السلامة قبل أول استخدام",
    product_install_s7: "اختبار جميع الوظائف الهوائية",
    product_install_tip: "نصيحة احترافية: استخدم مادة تثبيت الخيوط على براغي التركيب. تأكد من أن كمبروسر الهواء بسعة 8-10.5 جالون.",
    product_usage_heading: "كيفية تغيير الإطارات",
    product_usage_box_t: "عملية تغيير الإطارات الكاملة",
    product_usage_box_p: "يقدّم ميكانيكي محترف عرضًا كاملًا لتغيير الإطارات باستخدام LCTX:",
    product_usage_s1_s: "التحضير", product_usage_s1_d: "تفريغ الإطارة، تنظيف العجلة، وضع مادة تشحيم",
    product_usage_s2_s: "كسر الخرزة", product_usage_s2_d: "ضع الذراع، طبّق قوة 2000 كجم",
    product_usage_s3_s: "إزالة الإطارة", product_usage_s3_d: "تركيب العجلة، رفع الخرزات فوق النسم",
    product_usage_s4_s: "تركيب الإطارة", product_usage_s4_d: "ضع الإطارة، ادفع الخرزات فوق النسم",
    product_usage_s5_s: "النفخ", product_usage_s5_d: "تثبيت الخرزات، النفخ، موازنة العجلة",
    product_usage_tip: "استخدم دائمًا مادة تشحيم إطارات عالية الجودة. اعمل ببطء لتجنب تلف النسم.",
    product_usage_compat: 'متوافق: إطارات 12-21" — سيارات، دفع رباعي، شاحنات خفيفة، دراجات نارية (بمحول)، مركبات الطرق الوعرة.',
    product_video_cta: "اشترك على يوتيوب",
    product_video_cta_sub: "كن أول من يعلم بالدروس والنصائح الجديدة",
    product_tab_overview: "نظرة عامة",
    product_tab_specs: "المواصفات",
    product_tab_faq: "الأسئلة الشائعة",
    product_overview_h: "لماذا تختار LCTX؟",
    product_overview_p1: "مبدّل الإطارات الهوائي المصغّر من LCTX هو الحل الأمثل للميكانيكيين المتنقلين وهواة الأعمال اليدوية وكل من يحتاج لتغيير الإطارات أثناء التنقل. لا يحتاج كهرباء — فقط صله بكمبروسر الهواء وستكون جاهزًا للعمل!",
    product_overview_benefits: "الفوائد الرئيسية:",
    product_benefit1: "تصميم محمول: بوزن 80 رطلاً فقط، يمكنك نقله بسهولة في سيارتك",
    product_benefit2: "بدون كهرباء: يعمل مع أي كمبروسر هواء قياسي",
    product_benefit3: "قوة احترافية: عزم 2 طن يتعامل مع أصعب الإطارات",
    product_benefit4: "توافق واسع: يعمل مع مقاسات نسم 12-21 بوصة",
    product_benefit5: "تجهيز سريع: جاهز للاستخدام خلال دقائق",
    product_specs_h: "المواصفات الفنية",
    product_spec1_l: "نطاق قطر النسم", product_spec1_v: '12" - 21"',
    product_spec2_l: "أقصى قطر للعجلة", product_spec2_v: '39" (1000 ملم)',
    product_spec3_l: "ضغط التشغيل", product_spec3_v: "8-10 بار (116-145 PSI)",
    product_spec4_l: "قوة كسر الخرزة", product_spec4_v: "2000 كجم (2 طن)",
    product_spec5_l: "الوزن", product_spec5_v: "36 كجم (80 رطلاً)",
    product_spec6_l: "مصدر الطاقة", product_spec6_v: "هوائي (يعمل بالهواء)",
    product_spec7_l: "استهلاك الهواء", product_spec7_v: "يتطلب سعة 8-10.5 جالون",
    product_spec8_l: "الأبعاد", product_spec8_v: "تصميم مدمج ومحمول",
    product_faq1_q: "هل أحتاج كهرباء لاستخدام مبدّل الإطارات هذا؟",
    product_faq1_a: "لا! يعمل LCTX بالهواء المضغوط 100%. تحتاج فقط كمبروسر هواء بضغط 8-10 بار وسعة 8-10.5 جالون.",
    product_faq2_q: "ما مقاسات الإطارات التي يتعامل معها؟",
    product_faq2_a: 'يتعامل LCTX مع إطارات قطر نسم من 12" إلى 21"، ويغطي معظم سيارات الركاب وسيارات الدفع الرباعي والشاحنات الخفيفة.',
    product_faq3_q: "هل هو محمول فعلاً؟",
    product_faq3_a: "نعم! بوزن 80 رطلاً فقط (36 كجم)، يمكنك نقله بسهولة في سيارتك. مثالي للميكانيكيين المتنقلين والمساعدة على الطريق.",
    product_faq4_q: "ماذا يحتوي الطرد؟",
    product_faq4_a: "ستتلقى وحدة مبدّل الإطارات الكاملة مع جميع معدات التركيب والأغطية الواقية وعاروق الفك ودليل مستخدم شامل.",
    product_faq5_q: "كم يستغرق الشحن؟",
    product_faq5_a: "نشحن خلال 24-48 ساعة. يستغرق التوصيل 3-5 أيام عمل للمدن الكبرى و5-10 أيام للمناطق النائية.",
    product_parts_h: "ما الذي تحصل عليه — قائمة القطع",
    product_parts_sub: "عند شرائك مبدّل إطارات LCTX، ستتلقى صندوقين يحتويان على المكونات التالية:",
    product_part_1: "مجموعة ضبط المحور",
    product_part_2: "مجموعة الأسطوانة الكبيرة ودواسة القدم",
    product_part_3: "مجموعة ذراع الدفع",
    product_part_4: "مجموعة ذراع كسر الخرزة",
    product_part_5: "مخروط لتثبيت ثقب مركز محور العجلة",
    product_part_6: "صمولة كبيرة لقفل المخروط",
    product_part_7: "مجموعة تثبيت ودوران محور العجلة",
    product_part_8: "عاروق فك الإطارات",
    product_part_9: "قاعدة تثبيت مبدّل الإطارات",
    product_part_10: "حامل لتركيب الأسطوانة الكبيرة",
    product_part_11: "براغي لتركيب ذراع كسر الخرزة",
    product_part_12: "براغي لتركيب الأسطوانة الكبيرة",
    product_part_13: "مفتاح سداسي",
    product_part_14: "مفتاح ربط هنائي",
    product_parts_mobile: "عرض جميع القطع الـ 14 (اضغط للتوسيع)",
    product_parts_notice: "لعملاء الإمارات والسعودية: سيصل مبدّل إطارات LCTX في صندوقين منفصلين. يرجى فحص الصندوقين عند التوصيل والتأكد من وجود جميع القطع الـ 14 قبل التركيب.",
    product_guide_h: "دليل التركيب والاستخدام",
    product_guide_sub: "تعليمات خطوة بخطوة لاستخدام مبدّل إطارات LCTX",
    product_guide_inst_h: "إجراءات التركيب",
    product_guide_inst_p: "اتبع هذه الخطوات لإعداد مبدّل إطارات LCTX:",
    product_guide_inst_1: "توصيل الهواء: صل خرطوم كمبروسر الهواء بمدخل الهواء في المبدّل.",
    product_guide_inst_2: "ضع الوحدة: ضع المبدّل على سطح مستوٍ وثابت.",
    product_guide_inst_3: "ضبط الارتفاع: استخدم مجموعة ضبط المحور لضبط الارتفاع الصحيح لعجلتك.",
    product_guide_inst_4: "تثبيت القاعدة: تأكد من وضع القاعدة المثبّتة بشكل صحيح.",
    product_guide_inst_5: "اختبار التشغيل: قبل العمل على إطارة، اختبر جميع الوظائف الهوائية.",
    product_guide_rem_h: "كيفية فك إطارة",
    product_guide_rem_1: "تفريغ الإطارة: أزل صمام الإطارة وفرّغ الإطارة بالكامل.",
    product_guide_rem_2: "كسر الخرزة: استخدم ذراع كسر الخرزة لفصل الإطارة عن النسم من الجانبين.",
    product_guide_rem_3: "تركيب العجلة: ثبّت العجلة على المحور باستخدام المخروط القابل للقفل.",
    product_guide_rem_4: "التشحيم: ضع مادة تشحيم على الخرزتين والنسم.",
    product_guide_rem_5: "إزالة الخرزة الأولى: أدخل العاروق وادفع الخرزة الأولى فوق حافة النسم بعناية.",
    product_guide_rem_6: "إزالة الخرزة الثانية: كرر العملية للخرزة الثانية.",
    product_guide_ins_h: "كيفية تركيب إطارة",
    product_guide_ins_1: "فحص الإطارة: افحص الإطارة الجديدة للتأكد من عدم وجود تلف أو عيوب.",
    product_guide_ins_2: "التشحيم: ضع كميات وفيرة من مادة التشحيم على الخرزتين.",
    product_guide_ins_3: "وضع الخرزة الأولى: ضع الخرزة الأولى فوق النسم وادفعها للأسفل باستخدام العاروق.",
    product_guide_ins_4: "تركيب الخرزة الثانية: ادفع الخرزة الثانية فوق حافة النسم بعناية.",
    product_guide_ins_5: "النفخ: انفخ الإطارة ببطء مع التأكد من تثبيت الخرزتين على النسم.",
    product_guide_ins_6: "الموازنة: افحص موازنة الإطارة واقم بالتعديلات اللازمة.",
    product_guide_ins_7: "الفحص النهائي: افحص التركيب وتأكد من ضغط الإطارة.",
    product_manual_h: "حمّل دليل المستخدم الكامل",
    product_manual_p: "احصل على دليل PDF الشامل مع تعليمات ومخططات ومعلومات سلامة ونصائح استكشاف الأخطاء وإصلاحها لمبدّل إطارات LCTX.",
    product_manual_btn: "تحميل دليل PDF",
    product_manual_meta: "حجم الملف: 2.5 ميجابايت • الصيغة: PDF • اللغة: الإنجليزية",
    product_final_h: "جاهز للطلب؟",
    product_final_sub: "احصل على مبدّل إطارات LCTX موصلاً إلى بابك",
    product_final_footer: "شحن مجاني حول العالم • ضمان استرداد خلال 30 يومًا",

    // HOW TO USE PAGE
    htu_srh1: "كيفية استخدام مبدّل إطارات LCTX - دليل كامل خطوة بخطوة",
    htu_hero_badge: "دليل LCTX الرسمي",
    htu_hero_title: "كيفية استخدام مبدّل إطارات LCTX",
    htu_hero_sub: "دليل كامل خطوة بخطوة لتغيير الإطارات الاحترافي",
    htu_intro_p1: "صُمم ",
    htu_intro_p2: "مبدّل إطارات LCTX",
    htu_intro_p3: " لخدمة إطارات فعّالة ومحمولة. اتبع هذه العملية الكاملة لإزالة إطارة قديمة وتركيب إطارة جديدة بنجاح. يغطي هذا الدليل عملية تغيير الإطارات بالكامل من كسر الخرزة إلى التركيب النهائي.",
    htu_alert_strong: "قبل البدء:",
    htu_alert_text: " تأكد من توصيل كمبروسر الهواء وأنه يوفّر ضغطًا لا يقل عن 8 بار (116 PSI). ارتدِ نظارات السلامة والقفازات طوال العملية.",
    htu_video_h: "الدرس الرسمي بالفيديو",
    htu_video_sub: "شاهد العرض الكامل",
    htu_phase1_title: "المرحلة 1: إزالة الإطارة القديمة (الفك)",
    htu_phase1_sub: "اتبع هذه الخطوات لإزالة الإطارة القديمة من النسم بأمان",
    htu_p1_s1_h: "الخطوة 1: كسر الخرزة",
    htu_p1_s1_p1: "استخدم ",
    htu_p1_s1_p2: "كسّر الخرزة",
    htu_p1_s1_p3: " المدمج على جانب المachine لفصل خرزة الإطارة عن حافة النسم. ضع ذراع كسر الخرزة مقابل جدار الإطارة بالقرب من حافة النسم. طبّق ضغطًا هوائيًا باستخدام دواسة القدم لدفع الخرزة بعيدًا عن النسم. هذا يكسر الختم الذي يمسك الإطارة بالعجلة.كرر هذه العملية على جانبي الإطارة (الخرزتين العلوية والسفلية).",
    htu_p1_s2_h: "الخطوة 2: التشحيم",
    htu_p1_s2_p1: "ضع ",
    htu_p1_s2_p2: "مادة تشحيم الإطارات أو ماء صابوني",
    htu_p1_s2_p3: " بسخاء على خارج خرزة الإطارة وحافة النسم. هذا التشحيم حاسم — يقلل الاحتكاك ويمنع تلف الإطارة والنسم أثناء الإزالة. استخدم فرشاة أو بخاخ لضمان تغطية متساوية حول محيط الخرزة بالكامل.",
    htu_p1_s3_h: "الخطوة 3: تركيب العجلة بأمان",
    htu_p1_s3_p1: "ضع العجلة على ",
    htu_p1_s3_p2: "عمود المركز",
    htu_p1_s3_p3: " في المachine، مع التأكد من تثبيتها بإحكام باستخدام المخروط القابل للقفل والصمولة. يجب أن تستقر العجلة بشكل مسطح ومستقر على طاولة التركيب. أعد وضع الإطارة بحيث ",
    htu_p1_s3_p4: "يكون صمام الإطارة أمام المشغّل",
    htu_p1_s3_p5: " — هذا يسهّل العمل ويمنع تلف الصمام أثناء عملية تغيير الإطارات.",
    htu_p1_s4_h: "الخطوة 4: ضبط رأس التركيب (رأس البطة)",
    htu_p1_s4_p1: "اضبط ",
    htu_p1_s4_p2: "رأس التركيب",
    htu_p1_s4_p3: " في المachine (يُسمى غالبًا \"رأس البطة\") مقابل حافة النسم. تأكد من محاذاته بشكل صحيح لتوجيه الخرزة بسلاسة فوق النسم دون خدش أو تلف طلاء العجلة. يجب وضع رأس التركيب داخل الحافة الخارجية للنسم مباشرة.",
    htu_p1_s5_h: "الخطوة 5: رفع الخرزة",
    htu_p1_s5_p1: "أدخل ",
    htu_p1_s5_p2: "عاروق الإطارات",
    htu_p1_s5_p3: " (ذراع الفك) أسفل خرزة الإطارة العلوية، وضع العاروق خلف رأس التركيب مباشرة. استخدم العاروق لرفع الخرزة فوق رأس التركيب. هذا الرفع الأولي يبدأ عملية سحب الإطارة من النسم.",
    htu_p1_s6_h: "الخطوة 6: تدوير العجلة",
    htu_p1_s6_p1: "شغّل ",
    htu_p1_s6_p2: "آلية الدوران",
    htu_p1_s6_p3: " في المmachine باستخدام دواسة القدم أو المقبض اليدوي. أثناء دوران العجلة، حافظ على الضغط على عاروق الإطارات لإبقاء الخرزة مرفوعة. مجموع رأس التركيب وقوة العاروق سيدفع الخرزة تدريجيًا فوق حافة النسم. واصل الدوران حتى تُزال الخرزة العلوية بالكامل.",
    htu_p1_s7_h: "الخطوة 7: إزالة الخرزة الثانية",
    htu_p1_s7_p: "بمجرد إزالة الخرزة العلوية، اقلب العجلة وكرر عملية الرفع والدوران لإزالة الخرزة السفلية (الداخلية). ضع رأس التركيب، أدخل عاروق الإطارات، ودر العجلة حتى تنفصل الإطارة القديمة عن النسم بالكامل. أزل الإطارة المفكوكة تمامًا من العجلة.",
    htu_phase2_title: "المرحلة 2: تركيب الإطارة الجديدة (التركيب)",
    htu_phase2_sub: "اتبع هذه الخطوات لتركيب إطارتك الجديدة بشكل صحيح",
    htu_p2_s1_h: "الخطوة 1: التشحيم مرة أخرى",
    htu_p2_s1_p1: "ضع ",
    htu_p2_s1_p2: "مادة تشحيم إضافية",
    htu_p2_s1_p3: " على خرزات الإطارة الجديدة (العلوية والسفلية) وحواف النسم النظيف. التشحيم المناسب أكثر أهمية أثناء التركيب لمنع تلف الإطارة وضمان تثبيت سلس للخرزة. لا تقتصد في مادة التشحيم — استخدم الكثير حول المحيط بالكامل.",
    htu_p2_s2_h: "الخطوة 2: ضع الإطارة",
    htu_p2_s2_p: "ضع الإطارة الجديدة على النسم، مستندة على طاولة تركيب المachine. تأكد من أن علامة اتجاه دوران الإطارة (إن وُجدت) تطابق اتجاه دوران العجلة المقصود. حاذِ الإطارة لتستقر بالتساوي على النسم.",
    htu_p2_s3_h: "الخطوة 3: تركيب الخرزة الأولى",
    htu_p2_s3_p1: "استخدم ",
    htu_p2_s3_p2: "رأس التركيب",
    htu_p2_s3_p3: " للضغط على الخرزة الأولى (السفلية) للإطارة الجديدة على النسم. ضع رأس التركيب مقابل خرزة الإطارة ودر العجلة. سيوجّه رأس التركيب الخرزة فوق حافة النسم إلى مركز النسم العميق.",
    htu_p2_s4_h: "الخطوة 4: الرافعة والضغط",
    htu_p2_s4_p1: "طبّق ",
    htu_p2_s4_p2: "ضغطًا لأسفل",
    htu_p2_s4_p3: " على الجانب المقابل للإطارة (الجانب المقابل لرأس التركيب). يمكنك استخدام ذراع مساعدة أو قدمك أو أداة ضغط لدفع الإطارة للأسفل في مركز النسم العميق. هذا يخلق ارتخاءً لازمًا على الجانب الذي تعمل عليه، مما يجعل إدخال الخرزة الأخيرة فوق النسم أسهل بكثير.",
    htu_p2_s5_h: "الخطوة 5: إكمال التركيب",
    htu_p2_s5_p1: "شغّل ",
    htu_p2_s5_p2: "آلية الدوران",
    htu_p2_s5_p3: " مرة أخرى، دع رأس التركيب يضغط الخرزة الأخيرة (العلوية) بسلاسة فوق حافة النسم. واصل الدوران حتى تستقر الإطارة بالكامل على النسم. بعد الانتهاء، ركّب صمام الإطارة وانفخ الإطارة إلى الضغط الموصى به. تحقق من تثبيت الخرزتين على النسم قبل إزالة العجلة من المachine.",
    htu_safety_h: "نصائح سلامة مهمة",
    htu_safety_1_1: "ارتدِ دائمًا نظارات السلامة",
    htu_safety_1_2: " — قد تنبثق خرزات الإطارات وتسبب إصابات",
    htu_safety_2_1: "استخدم تشحيمًا مناسبًا",
    htu_safety_2_2: " — لا تفرض إطارة جافة على النسم أبدًا",
    htu_safety_3_1: "تحقق من ضغط كمبروسر الهواء",
    htu_safety_3_2: " — حافظ على 8-10 بار (116-145 PSI)",
    htu_safety_4_1: "افحص الإطارات قبل التركيب",
    htu_safety_4_2: " — ابحث عن التلف أو العيوب",
    htu_safety_5_1: "لا تتجاوز ضغط النفخ الموصى به أبدًا",
    htu_safety_5_2: " أثناء تثبيت الخرزة",
    htu_cta_h: "جاهز للحصول على مبدّل إطارات LCTX؟",
    htu_cta_sub: "ابدأ تغيير الإطارات في أي مكان بحلنا الهوائي المحمول",
    htu_cta_btn1: "عرض تفاصيل المنتج",
    htu_cta_btn2: "شاهد المزيد من الدروس",
    htu_cta_footer: "✅ شحن مجاني • ✅ ضمان 30 يومًا • ✅ أفضل سعر",
  },
};